/*
 * Platform.
 */

import { isString, memoize } from 'lodash-es';
import { getGlobalWindow } from '../dom/global';

enum PlatformsEnum {
  WINDOWS = 'WINDOWS',
  MACOS = 'MACOS',
  LINUX = 'LINUX',
}

export const findPlatform = memoize((): PlatformsEnum | undefined => {
  const window = getGlobalWindow();

  if (!window) return undefined;

  // We can switch to navigator.userAgentData.platform once it is no longer experimental and typed in Typescript.
  //  https://erikmartinjordan.com/navigator-platform-deprecated-alternative.
  const { platform } = window.navigator;

  // navigator.platform is an empty array on React Native 0.66.
  if (!isString(platform)) return undefined;

  const browserPlatform = platform.toLowerCase();

  if (browserPlatform.includes('mac')) return PlatformsEnum.MACOS;

  if (browserPlatform.includes('linux')) return PlatformsEnum.LINUX;

  return PlatformsEnum.WINDOWS;
});

export function isMacOS(): boolean {
  return findPlatform() === PlatformsEnum.MACOS;
}
